import { toast } from 'react-toastify'

export const successToastMessage = (message: string) => toast.success(message)
